import { Component, OnInit, Input, Output, EventEmitter, OnDestroy  } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { LoanService } from '../../services/loan.service';
import { EmployeeService } from '../../services/employee.service';

import { Utils } from '../../util';

@Component({
    selector: 'app-update-loan',
    templateUrl: './update-loan.component.html',
    styleUrls: ['./update-loan.component.css', '../../app.component.css']
})

export class UpdateLoanComponent implements OnInit, OnDestroy {

    loanForm: FormGroup;
    loan: any = [];

    employees = {};
    employeeInit: any;
    employeeText = '';

    authorizes = {};
    authorizeInit: any;
    authorizeText = '';

    pickadateParams = Utils.pickadateParams();

    id: string;
    loanDate: any;

    glSubs: any;
    gelSubs: any;
    geaSubs: any;
    geSubs: any;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private activatedRoute: ActivatedRoute,
                private loanService: LoanService,
                private employeeService: EmployeeService) {
        this.loadEmployeesAndAuthorizes();

        this.activatedRoute.params.subscribe(parameters => {
            this.id = parameters['id'];

            this.glSubs = this.loanService.getLoan(this.id).subscribe(loanObj => {
                this.glSubs.unsubscribe();

                this.loan = loanObj;

                this.loanDate = Utils.convertDatefromStringtoISOString(this.loan.loanDate);

                this.gelSubs = this.employeeService.getEmployee(this.loan.employeeId).subscribe(employeeObj => {
                    this.gelSubs.unsubscribe();

                    this.employeeText = employeeObj.name + ' ' + employeeObj.lastName;
                });

                this.geaSubs = this.employeeService.getEmployee(this.loan.authorizeId).subscribe(authorizeObj => {
                    this.geaSubs.unsubscribe();

                    this.authorizeText = authorizeObj.name + ' ' + authorizeObj.lastName;
                });
            });

            
        });
    }

    ngOnInit() {
        this.loanForm = this.formBuilder.group({
            loanDate: ['', Validators.required],
            employee: ['', Validators.required],
            authorize: ['', Validators.required],
            loanAmount: ['', Validators.required],
            discountPerPayroll: ['', [Validators.required]]
        });
    }

    onSubmitLoan() {
        this.loan = this.saveLoan();

        this.loanService.putLoan(this.loan, this.id).then(res => {
            this.router.navigate(['/loans']);
        });
    }

    saveLoan() {
        const loanDate = Utils.convertDatefromISOStringtoObject(this.loanForm.get('loanDate').value);

        const loanJson = {
            authorizeId: this.authorizes[this.loanForm.get('authorize').value],
            authorizeName: this.loanForm.get('authorize').value,
            discountPerPayroll: this.loanForm.get('discountPerPayroll').value,
            employeeId: this.employees[this.loanForm.get('employee').value],
            employeeName: this.loanForm.get('employee').value,
            loanAmount: this.loanForm.get('loanAmount').value,
            loanDate: loanDate,
            updatedAt: new Date(),
        };

        return loanJson;
    }

    loadEmployeesAndAuthorizes() {
        this.geSubs = this.employeeService.getEmployees().subscribe(tempEmployees => {
            const data = {};

            for (const idx in tempEmployees) {
                let employeeDisplayValue = `${tempEmployees[idx].name} ${tempEmployees[idx].lastName} (${tempEmployees[idx].internalKey})`;
                data[employeeDisplayValue] = null;

                this.employees[employeeDisplayValue] = tempEmployees[idx].id$;
                this.authorizes[employeeDisplayValue] = tempEmployees[idx].id$;
            }

            this.employeeInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.employees[val]);
                }
            };

            this.authorizeInit = {
                'data': data,
                onAutocomplete: (val) => {
                    // console.log(val);
                    // console.log(this.authorizes[val]);
                }
            };
        });
    }

    onBlurEmployee() {
        if (this.employees[this.employeeText] === undefined) {
            this.employeeText = '';
        }
    }

    onBlurAuthorize() {
        if (this.authorizes[this.authorizeText] === undefined) {
            this.authorizeText = '';
        }
    }

    ngOnDestroy() {
        this.geSubs.unsubscribe();
    }

}

